import { memo, ReactNode } from 'react'
import cn from 'classnames'

interface IProps {
  children?: ReactNode
  className?: string
  testId?: string
}

export const List = memo<IProps>(function List({ children, className, testId }) {
  return (
    <div
      data-name="table"
      data-test-id={testId}
      className={cn(
        'overflow-hidden rounded-sm bg-surface text-on-surface/[.20] shadow-[0_1px_3px_rgb(26,28,30,0.2)] max-md:overflow-auto max-md:rounded-none [&>div:not(:first-child)]:border-t [&>div:not(:first-child)]:border-t-on-surface/[.12]',
        className
      )}
    >
      {children}
    </div>
  )
})
